import client from "./client";

export const listEmployeeDocs = async (userId) => (await client.get(`/employee-docs/${userId}`)).data;

export const addEmployeeDoc = async (userId, { file, kind, title, number, expiry }) => {
  const data = new FormData();
  data.append("file", file);
  data.append("kind", kind);
  data.append("title", title || "");
  data.append("number", number || "");
  data.append("expiry", expiry || "");
  const res = await client.post(`/employee-docs/${userId}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteEmployeeDoc = (docId) => client.delete(`/employee-docs/item/${docId}`);
